import { EnumSchema } from '../metadata-schema';

export const PlaatsingUitzondering: EnumSchema = {
	"type": "string",
	"title": "PlaatsingUitzondering",
	"enum": [
		"Plaatsing telt mee",
		"Geen relevante plaatsing",
		"Geen 1-oktoberplaatsing",
		"Tussentijdse instroom"
	]
};
